// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2921":"2c57d51866f0427cda15","7252":"28ffe5d01213ed66e2c2"}[chunkId] + ".js";
};